// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;You, O Lord, will watch over us&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and guard us from this generation for ever.<br> </p> </div></div>";
// Exports
module.exports = code;